import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'react-bootstrap'
import { map, uniq, flatMap, sortBy, uniqBy, startCase } from 'lodash'

import { getDefaultFiltersFromParams } from 'Utilities/filters'
import { arrayToOptions } from 'Utilities/selectOptions'
import { ReportFilters, defaultFilters } from './Filters'
import { CustomerTable } from './CustomerTable'
import { filteredCustomers, sendVMsToUpdate } from './Data';

const CloudCoreConsumptionReport = ({ customers, locations, showFilters, reportSize, filterParams, billing, asset_types }) => {
  const customerOptions = map(customers, customer => ({ value: customer.customer_id, label: customer.customer_name }))
  const clusters = map(uniqBy(flatMap(customers, customer => map(customer.cluster_functions, ({ id, name }) => ({ id, name }))), 'id'),
    ({ id, name }) => ({ label: name, value: id })
  )
  const clusterFunctions = map(uniq(flatMap(customers, customer => map(customer.cluster_functions, 'function'))),
    clusterFunction => ({ label: clusterFunction, value: clusterFunction })
  )
  const clusterOwnership = map(uniq(flatMap(customers, customer => map(customer.cluster_functions, 'ownership'))),
    clusterFunction => ({ label: clusterFunction, value: clusterFunction })
  )

  const filterOptions = {
    powerState: { isMulti: false, options: arrayToOptions(['All', 'On', 'Off']) },
    locations: { isMulti: true, options: sortBy(locations, 'label') },
    clusters:  { isMulti: true, options: sortBy(clusters, 'label') },
    functions: { isMulti: true, options: sortBy(clusterFunctions, 'label') },
    ownership: { isMulti: true, options: sortBy(clusterOwnership, 'label') },
    customers: { isMulti: true, options: sortBy(customerOptions, 'label') },
    customerStatus: { isMulti: true, options: arrayToOptions(['live', 'historic', 'pending offboarding'], startCase) },
    assetTypes: { isMulti: true, options: arrayToOptions(asset_types) },
    managedByCalligo: { isMulti: false, options: [{ label: 'All', value: 'All' }, { label: 'Calligo', value: true }, { label: 'Customer', value: false }, { label: 'Shared', value: null }] },
    billable: { isMulti: false, options: [{ label: 'All', value: 'All' }, { label: 'Billable', value: true }, { label: 'Not billable', value: false }] }
  }
  const [filters, changeFilters] = useState(getDefaultFiltersFromParams({ filterParams, defaultFilters, filterOptions }))
  const [vmsToUpdate, updateVMs] = useState([])
  const [flashMessage, setFlashMessage] = useState(null)

  return (
    <Fragment>
      {showFilters && <ReportFilters {...{ filters, filterOptions, changeFilters }} />}

      {billing && (
        <div className="row mb-3">
          <div className="col d-flex justify-content-end">
            <button className='btn btn-primary' onClick={event => sendVMsToUpdate(event, vmsToUpdate, setFlashMessage)}>
              Update VMs
            </button>
          </div>
        </div>
      )}

      {flashMessage && (
        <div className="row mb-3">
          <div className="col">
            <Alert key={`alert-${flashMessage.variant}`} variant={flashMessage.variant} dismissable>
              {flashMessage.message}
            </Alert>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col">
          <CustomerTable {...{
            customers: filteredCustomers({ customers, filters }),
            filters,
            changeFilters,
            billing,
            vmsToUpdate,
            updateVMs,
            defaultPageSize: { small: 5, regular: 20, large: 100 }[reportSize]
          }}/>
        </div>
      </div>
    </Fragment>
  )
}


CloudCoreConsumptionReport.propTypes = {
  customers: PropTypes.arrayOf(PropTypes.shape),
  locations: PropTypes.arrayOf(PropTypes.shape),
  showFilters: PropTypes.bool,
  reportSize: PropTypes.oneOf(['small', 'regular']),
  filterParams: PropTypes.shape,
  billing: PropTypes.bool
}

CloudCoreConsumptionReport.defaultProps = {
  showFilters: true,
  reportSize: 'regular',
  filterParams: {},
  billing: false
}

export default CloudCoreConsumptionReport
